import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { setHeaderPanelExpand } from 'redux/app/actions';
import { updateShowNotificationOptionsModal } from 'redux/user/actions';
import {
  contactSupportFlag,
  updateProfileUpdatingFlag
} from 'redux/user/actions';
import { useDispatch, useSelector } from 'react-redux';
import {
  Switcher,
  SwitcherItem,
  SwitcherDivider,
  Loading
} from 'carbon-components-react';
import Service from 'services';
import { selectSignOutState } from 'redux/app/selectors';
import { currentUser } from 'redux/session/selectors';
import { selectUser } from 'redux/user/selector';
import { APP_URL, DBYD_1100_URL } from 'types';
import { isResidentialUser } from 'utilities/residential-redirect.util';

// Temporary block - need to delete after Helix enabled
import { selectRemedyForceClient } from 'redux/user/selector';
// Temporary block

const UserPanel: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user: any = useSelector(selectUser);
  const sessionUser: any = useSelector(currentUser);
  const isResidentialEnquirer = isResidentialUser(sessionUser);
  const isLoading = useSelector(selectSignOutState);
  const handleLogout = useCallback(async () => {
    await Service.auth.ssoLogout();
  }, []);

  // Temporary block - need to delete after Helix enabled
  const isRemedyForceClient = useSelector(selectRemedyForceClient);
  // Temporary block

  const handleOpenProfile = () => {
    dispatch(updateProfileUpdatingFlag(true));
    dispatch(setHeaderPanelExpand({ panel: 'account', isOpen: false }));
  };

  const handleOpenContactSupport = () => {
    // Temporary block - need to delete after Helix enabled
    if (process.env.REACT_APP_REMEDY_FORCE_ENABLED === 'true') {
      if (!isRemedyForceClient) {
        dispatch(contactSupportFlag(true));
        dispatch(setHeaderPanelExpand({ panel: 'account', isOpen: false }));
      } else {
        window.open(
          process.env.REACT_APP_REMEDY_FORCE_SUPPORT_URL,
          '_blank',
          'noreferrer'
        );
      }

      return;
    }
    // Temporary block

    dispatch(contactSupportFlag(true));
    dispatch(setHeaderPanelExpand({ panel: 'account', isOpen: false }));
  };

  const handleGoToResidentialView = () => {
    window.location.assign(APP_URL.RESIDENTIAL_ENQUIRY);
  };

  const toggleNotificationOptions = (val: boolean) => {
    dispatch(updateShowNotificationOptionsModal(val));
  };

  return (
    <div className="user-panel--wrapper">
      <Switcher aria-label="Switcher Container">
        <SwitcherItem aria-label="Profile" onClick={() => handleOpenProfile()}>
          My profile
        </SwitcherItem>
        <SwitcherItem
          aria-label="Privacy policy"
          href={DBYD_1100_URL.PRIVACY_POLICY}
          target="_blank"
        >
          Privacy
        </SwitcherItem>

        <SwitcherItem
          className="response-notification"
          aria-label="Response notification options"
          onClick={() => toggleNotificationOptions(true)}
        >
          Response notification options
        </SwitcherItem>

        {isResidentialEnquirer && (
          <SwitcherItem
            aria-label="Switch to residential view"
            onClick={handleGoToResidentialView}
          >
            Switch to residential view
          </SwitcherItem>
        )}

        <SwitcherItem
          className="emergency--link"
          aria-label="Emergency"
          onClick={() => history.push(APP_URL.EMERGENCY)}
        >
          Emergency
        </SwitcherItem>
        <SwitcherDivider />
        <SwitcherItem
          aria-label="Contact support"
          onClick={() => handleOpenContactSupport()}
        >
          Contact support
        </SwitcherItem>
        <SwitcherDivider />
        <SwitcherItem
          aria-label={`Signed in as ${user?.email}`}
          className="signed-in-as--wrapper"
        >
          <label>Signed in as</label>
          <div>{user?.email}</div>
        </SwitcherItem>
        <SwitcherItem
          className="logout-button--wrapper"
          onClick={() => handleLogout()}
          aria-label="Sign out"
        >
          <span>Sign out</span>
          {isLoading && (
            <Loading
              small
              description="Active loading indicator"
              withOverlay={false}
            />
          )}
        </SwitcherItem>
      </Switcher>
    </div>
  );
};

const propTypes = {
  isExpanded: PropTypes.bool,
  userRole: PropTypes.string || undefined
};

type Props = PropTypes.InferProps<typeof propTypes>;

UserPanel.propTypes = propTypes;

UserPanel.defaultProps = {
  isExpanded: false,
  userRole: undefined
};

export default UserPanel;
